export const PROGRAM_RETIRED_MESSAGE = "This program is retired";

export const PROGRAM_UNAVAILABLE_MESSAGE =
  "This program is currently unavailable for purchase. Associated courses may still be open for enrollment.";
